module.exports = __webpack_public_path__ + "img/icon4.80fa3a6e.png";